import React from 'react';
import { WebSocketProvider } from '@shared/contexts/WebSocketContext';
import { useMessageCounter } from '@shared/contexts/MessageCounterContext';
import { useNotificationSound } from '@shared/hooks/useNotificationSound';
import { useNotifications } from '@shared/hooks/useNotifications';

interface WebSocketCallbacksProps {
  children: React.ReactNode;
}

export const WebSocketCallbacks: React.FC<WebSocketCallbacksProps> = ({ children }) => {
  const { incrementUnreadCount } = useMessageCounter();
  const { playNotificationSound } = useNotificationSound();
  const { showInfo } = useNotifications();

  return (
    <WebSocketProvider
      options={{
        onMessage: (message) => {
          if (import.meta.env.DEV) {
            console.log('📩 WebSocket mensaje recibido:', message);
          }

          if (message.action === 'processed_message' && message.data) {

            showInfo(message.data.content, message.data.title || 'Nueva notificación');

            incrementUnreadCount();

            playNotificationSound();

            const event = new CustomEvent('ws-new-notification', { detail: message.data });
            window.dispatchEvent(event);
          }
        },
        onConnect: () => {
          if (import.meta.env.DEV) {
            // eslint-disable-next-line no-console
            console.log('✅ WebSocket conectado');
          }
        },
        onDisconnect: () => {
          if (import.meta.env.DEV) {
            // eslint-disable-next-line no-console
            console.log('❌ WebSocket desconectado');
          }
        },
        onError: (error) => {
          if (import.meta.env.DEV) {
            // eslint-disable-next-line no-console
            console.log('⚠️ WebSocket error:', error);
          }
        },
      }}
    >
      {children}
    </WebSocketProvider>
  );
};
